module.exports = __webpack_public_path__ + "static/media/dashboard_image.e5937523.svg";